import { __module as n } from "../../../_virtual/isStrongPassword.js";
import { m as e } from "./util/merge.js";
import { a as o } from "./util/assertString.js";
!function (n, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (n) {
    var e,
      o,
      t,
      i,
      C = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
    (0, s.default)(n);
    var c = (e = {}, Array.from(n).forEach(function (n) {
      e[n] ? e[n] += 1 : e[n] = 1;
    }), o = {
      length: n.length,
      uniqueChars: Object.keys(e).length,
      uppercaseCount: 0,
      lowercaseCount: 0,
      numberCount: 0,
      symbolCount: 0
    }, Object.keys(e).forEach(function (n) {
      u.test(n) ? o.uppercaseCount += e[n] : a.test(n) ? o.lowercaseCount += e[n] : p.test(n) ? o.numberCount += e[n] : m.test(n) && (o.symbolCount += e[n]);
    }), o);
    return (C = (0, r.default)(C || {}, l)).returnScore ? (t = C, i = 0 + c.uniqueChars * t.pointsPerUnique + (c.length - c.uniqueChars) * t.pointsPerRepeat, c.lowercaseCount > 0 && (i += t.pointsForContainingLower), c.uppercaseCount > 0 && (i += t.pointsForContainingUpper), c.numberCount > 0 && (i += t.pointsForContainingNumber), c.symbolCount > 0 && (i += t.pointsForContainingSymbol), i) : c.length >= C.minLength && c.lowercaseCount >= C.minLowercase && c.uppercaseCount >= C.minUppercase && c.numberCount >= C.minNumbers && c.symbolCount >= C.minSymbols;
  };
  var r = i(e),
    s = i(o);
  function i(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  var u = /^[A-Z]$/,
    a = /^[a-z]$/,
    p = /^[0-9]$/,
    m = /^[-#!$@%^&*()_+|~=`{}\[\]:";'<>?,.\/ ]$/,
    l = {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
      returnScore: !1,
      pointsPerUnique: 1,
      pointsPerRepeat: .5,
      pointsForContainingLower: 10,
      pointsForContainingUpper: 10,
      pointsForContainingNumber: 10,
      pointsForContainingSymbol: 10
    };
  n.exports = t.default, n.exports.default = t.default;
}(n, n.exports);
var t = n.exports;
export { t as i };